import { Container, Stack, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import RetailerContext from '../context';

import useSWR from 'swr';

import '../styles/Footer.scss';

import ScanImage from '../shared/img/scan.webp';
import ScanImageWhite from '../shared/img/scan-white.png';
import { Box } from '@mui/material';
import Menu from './Menu';
import api from '../api';
import notify from './Notification/helper';
import { ModalContainer } from './shared/ModalContainer';
import CallToActionMarquee from './CallToActionMarquee';

import { useSelector } from 'react-redux';
import { hexToRgb, isLight } from '../utils/colour';
import { fetcher } from '../utils/fetcher';
import { getTranslation } from '../utils/translate';
import DialogTraining from './DialogTraining';

const Footer = () => {
  const { t } = useTranslation();
  const retailerContext = useContext(RetailerContext);

  const languageCode = useSelector(state => state.language.code);

  const [footerMenuId, setFooterMenuId] = useState(null);
  const [bottomFooterMenuId, setBottomFooterMenuId] = useState(null);

  const contests = useSelector(state => state.contests);
  const contest = contests?.find(item => item?.id) || null;

  let translatedCallToAction = {};
  let callToAction = null;
  let callToActionImage = null;

  const { data } = useSWR({
    url: `call_to_action`,
    fields: '*,translations.*,retailers.retailer_id',
  }, fetcher);

  if (data) {
    if (data.status === 'published' && data.retailers.some(retailer => retailer.retailer_id === retailerContext.retailer.id)) {
      callToAction = data;
      translatedCallToAction = getTranslation(callToAction, { key: 'languages_code', code: languageCode });
    }

    if (data.featured_image) {
      callToActionImage = `${process.env.REACT_APP_API_URL}/assets/${data.featured_image}`;
    }
  }

  useEffect(async () => {
    try {
      const defaultsResponse = await api.getDefaults();

      if (retailerContext.retailer.footer_menu) {
        setFooterMenuId(retailerContext.retailer.footer_menu);
      } else {
        setFooterMenuId(defaultsResponse.footer_menu)
      }

      if (retailerContext.retailer.footer_menu_bottom) {
        setBottomFooterMenuId(retailerContext.retailer.footer_menu_bottom);
      } else {
        setBottomFooterMenuId(defaultsResponse.footer_menu_bottom)
      }
    } catch (error) {
      error.map((err) => notify('error', err.message));
    }
  }, []);

  return (
    <Box
      className='no-print'
      sx={{
        mt: 8,
        width: '100%',
        background: '#000'
      }}
    >
      <DialogTraining />
      {
        !!contest && <ModalContainer />
      }

      {
        !!callToAction &&
        <CallToActionMarquee
          ctaText={translatedCallToAction?.button_text}
          ctaLink={callToAction?.button_url}
          title={translatedCallToAction?.title}
          message={translatedCallToAction?.message}
          bannerImage={callToActionImage}
          dateUpdated={callToAction.date_updated}
        />
      }

      <Container
        className='padding-on-mobile'
      >
        {
          !!footerMenuId &&
          <Menu 
            id={footerMenuId}
            variant={'inline'}
          />
        }
        
        <Box
          sx={{
            py: 2,
            textAlign: 'justify'
          }}
        >
          <Typography
            variant='span'
            sx={{
              color: '#ffffff',
              fontSize: '0.8em'
            }}
            >
              {t('disclaimer')}
            </Typography>
        </Box>

        {
          !!bottomFooterMenuId &&
          <Menu
            id={bottomFooterMenuId}
            variant={'inline'}
          />
        }
      </Container>

      {
        retailerContext.retailer.allow_scanning &&
        <Link className="footer-btn" to="/scanner">
          <div className="footer">
            <div style={{ position: 'relative', height: '100%' }}>
              <svg style={{ position: 'absolute', width: '100%', height: '100%' }}>
                <mask id='m' fill='#fff'>
                  <rect id='r' width='100%' height='100%' />
                  <circle id='c' r='20' fill='#000' />
                </mask>
                <use xlinkHref='#r' fill={retailerContext.retailer.button_background_color} mask='url(#m)' />
              </svg>
              <Stack
                alignItems={'center'}
                justifyContent={'center'}
                style={{ 'backgroundColor': 'transparent', position: 'absolute', width: '100%', height: '100%' }}
              >
                {
                  isLight(hexToRgb(retailerContext.retailer.button_background_color)) ? 
                  <img src={ScanImage} style={{width: '50%'}}alt="" /> : 
                  <img src={ScanImageWhite} style={{width: '50%'}}alt="" />
                }
                <Typography
                  sx={{
                    fontSize: '13px',
                    color: isLight(hexToRgb(retailerContext.retailer.button_background_color)) ? '#000' : '#fff',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                  className="font-primary"
                >
                  {t('scanHere')}
                </Typography>
              </Stack>
            </div>
          </div>
        </Link>
      }
    </Box>
  )
};

export default Footer; 